export default "__VITE_ASSET__03e76d0d__"